import { jsx as _jsx } from "react/jsx-runtime";
import { Slot } from "./Slot";
function TabList(param) {
  var { asChild, ...props } = param;
  var Comp = asChild ? Slot : "nav";
  return /* @__PURE__ */ _jsx(Comp, {
    ...props
  });
}
function isTabList(child) {
  return child.type === TabList;
}
export {
  TabList,
  isTabList
};
//# sourceMappingURL=TabList.js.map
